"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { recordVisit } from "@/lib/visit-attribution";

// Pages a prospective hotel reads; the server applies the same list.
const LANDING = ["/", "/public"];
const SECTIONS = ["/public/blog", "/public/solutions", "/public/systems", "/public/ownerd", "/public/book-demo", "/public/claim-organization"];

export default function VisitTracker() {
  const pathname = usePathname() || "";
  useEffect(() => {
    const path = pathname.replace(/\/+$/, "") || "/";
    if (LANDING.includes(path) || SECTIONS.some((section) => path === section || path.startsWith(`${section}/`))) recordVisit(path);
  }, [pathname]);
  return null;
}
